/**
 * KAN-751: структурированные инструкции оператора.
 *
 * Реестр частей (ключ, заголовок, подсказка, пометка про инструмент) и
 * превью собранного текста. Все URL этого блока живут только здесь.
 */
import apiClient from './client';
import type {
  OperatorSectionMeta,
  PromptSections,
  PromptSectionsPreview,
} from '../../types/user';

export const OPERATOR_SECTIONS_URL = '/api/v1/users/operator-sections/';

export const promptSectionsPreviewUrl = (userId: string): string =>
  `/api/v1/users/${userId}/prompt-sections/preview/`;

export const operatorSectionsApi = {
  /** Реестр частей в порядке отображения. */
  list: async (): Promise<OperatorSectionMeta[]> => {
    const response = await apiClient.get<OperatorSectionMeta[]>(OPERATOR_SECTIONS_URL);
    return Array.isArray(response?.data) ? response.data : [];
  },

  /** Собранный текст инструкций так, как его получит бот. */
  preview: async (
    userId: string,
    promptSections: PromptSections
  ): Promise<PromptSectionsPreview> => {
    const response = await apiClient.post<Partial<PromptSectionsPreview>>(
      promptSectionsPreviewUrl(userId),
      { prompt_sections: promptSections }
    );
    return { text: response.data?.text ?? '', legacy: response.data?.legacy === true };
  },
};
